module.exports = __webpack_public_path__ + "static/media/aws_2019.9269b027.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/files/aws_2019.pdf
// module id = 98
// module chunks = 0